import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CheckVerified03 = function CheckVerified03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m9 12 2 2 4.5-4.5M9.2019 20.6009a1.24 1.24 0 0 1 .9199.2466l1.2033.9233a1.105 1.105 0 0 0 1.3476 0l1.2488-.9588a1.105 1.105 0 0 1 .8188-.2189l1.5621.2055a1.108 1.108 0 0 0 1.1677-.6744l.6011-1.4533a1.103 1.103 0 0 1 .5999-.6l1.4532-.6011c.4633-.1911.74-.671.6744-1.1677l-.1977-1.5055a1.24 1.24 0 0 1 .2466-.92l.9233-1.2033a1.1054 1.1054 0 0 0 0-1.3477l-.9589-1.2489a1.105 1.105 0 0 1-.2188-.8189l.2055-1.5621a1.108 1.108 0 0 0-.6744-1.1678l-1.4532-.601a1.103 1.103 0 0 1-.5999-.6l-.6011-1.4533a1.107 1.107 0 0 0-1.1677-.6745l-1.5621.2056a1.1 1.1 0 0 1-.8177-.2167l-1.2488-.9588a1.105 1.105 0 0 0-1.3476 0l-1.2488.9588a1.115 1.115 0 0 1-.8188.219l-1.5621-.2056a1.108 1.108 0 0 0-1.1677.6744l-.6 1.4533a1.117 1.117 0 0 1-.6.6l-1.4531.6c-.4633.1922-.74.671-.6744 1.1677l.2055 1.5622a1.11 1.11 0 0 1-.2188.8177l-.9588 1.2489a1.1054 1.1054 0 0 0 0 1.3477l.9588 1.2489a1.105 1.105 0 0 1 .2188.8188l-.2055 1.5622c-.0656.4967.211.9755.6744 1.1678l1.4532.6011c.2722.1122.4877.3277.6.5999l.601 1.4533c.1911.4634.671.74 1.1677.6745z"
    })
  }));
};
export default CheckVerified03;